import React, { useState } from 'react';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

const Category = ({ title, hide = false, problem, children }) => {
	// Store category's expanded state
	const [show, setShow] = useState(!hide);

	// Toggle category's expansion
	const toggle = () => setShow(p => !p);

	return (
		<div>
			<div
				onClick={toggle}
				className="px-4 h-10 leading-10 flex items-center justify-between space-x-2 rounded-lg bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 cursor-pointer transition-colors"
			>
				<div className="font-semibold text-neutral-700 dark:text-white flex-1">
					{title}
				</div>

				<Show if={problem}>
					<Icon
						icon="exclamation"
						className="text-lg font-semibold text-neutral-100 bg-rose-500 rounded-full w-5 h-5 text-center leading-5"
					/>
				</Show>
				
				<Icon
					icon={show ? 'expand_less' : 'expand_more'}
					className="text-lg leading-10 text-neutral-700 dark:text-neutral-100"
				/>
			</div>

			<Show if={show}>
				<div className="py-3 px-4 space-y-2 animate-fade-in">
					{children}
				</div>
			</Show>
		</div>
	);
};

export default Category;
